import $ from "jquery";
window.jQuery = $;
window.$ = $;
import angular from "angular";
import ngAnimate from "angular-animate";
import uiRouter from "@uirouter/angularjs";
import ngMaterial from "angular-material";
require("angular-lazy-img/dist/angular-lazy-img.min.js");
import moment from "moment";
import "moment/min/locales"; 
require("./libs/angular/angular-aria.min.js");
require("mdPickers");
require("mdPickers/dist/mdPickers.min.css");
require("./libs/angular/angular-material.min.js");
require("./libs/angular/angular-messages.min.js");
require("./libs/slick/slick.min.js");
require("./libs/slick/slick-angular.js");
require("./libs/datepicker/angular-datepicker.min.js");
require("oclazyload");
 
require("./libs/angular/ngStorage.min.js");

require("./libs/angular/angularSlideables.js");
require("./libs/angular/angular-facebook.js");

require("./libs/angular/ui-bootstrap-tpls-1.2.1.js");

require("./libs/lodash/lodash.core.min.js");

require("./libs/angular-google-places-autocomplete/autocomplete.min.js");
require("./libs/sweetalert/sweetalert.min.js");
require("./libs/loader/loading-bar.js");
require("./libs/js/bootstrap.js");

require("./libs/js/owl-carousel.js");
require("./libs/js/bootstrap-timepicker.js");
require("./libs/js/nicescroll.js");
require("./libs/js/ionsrangeslider.js");
require("./libs/js/bootstrap-datepicker.js");

require("./libs/js/magnific-main.js");

require("./libs/js/icheck-main.js");

require("./libs/js/dropit.js");
require("./libs/js/fitvids.js");
require("./meta.js");
//require("./libs/phonepesdk.js");
var extractedCity = "";

require("./libs/angular/angular-material.css");
require("owl.carousel/dist/assets/owl.carousel.min.css");
require("./libs/css/bootstrap.css");
require("font-awesome/css/font-awesome.css");
require("./libs/css/icomoon.css");
require("./libs/css/styles.css");
require("./libs/css/mystyles.css");
require("./libs/angular-google-places-autocomplete/autocomplete.min.css");
require("./libs/css/newcss.css");
require("./libs/sweetalert/sweetalert.css");
require("./libs/loader/loading-bar.css");
require("./libs/css/loading-b.css");
require("./libs/css/loading-btn.css");

import IndexController from "./index.controller";
import network from "./app/services/networkFactory";

var myApp = angular.module("app", [
  uiRouter,
  "slick",
  "angularSlideables",
  ngMaterial,
  ngAnimate,
  "ngAria",
  "ngMessages",
  "mdPickers",
  "google.places",
  "ngStorage",
  "facebook",
  "ui.bootstrap",
  "720kb.datepicker",
  "chieffancypants.loadingBar",
  "oc.lazyLoad",
  "angularLazyImg"
]);

require("./app/config.js").default(myApp);
require("./app/directive.js").default(myApp);

myApp.controller("IndexController", IndexController);
myApp.factory("network", network);
